<template>
  <div>
    <a-modal
      width="40%"
      title="工作室基本信息"
      destroy-on-close
      :visible.sync="visible"
      append-to-body
      ok-text="提交"
      cancel-text="取消"
      @ok="goStep"
      @cancel="handleCancel"
    >
      <div class="card-item">
        <!-- <div class="title-box">
          <span class="title-text">品牌基本信息</span>
        </div> -->
        <div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>品牌名称
              </div>
              <div class="pl16">
                <a-input
                  class="input-style-2"
                  type="text"
                  placeholder="请输入品牌名称"
                  :maxLength="100"
                  v-model="info.name"
                  :disabled="isEdit || isScore"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>申报年份
              </div>
              <div class="pl16">
                <a-date-picker
                  placeholder="请选择申报年份"
                  v-model="info.applyYear"
                  :disabled="!isRevise || isScore"
                  :open="yearShowOne"
                  :locale="locale"
                  :format="'YYYY'"
                  mode="year"
                  @openChange="openChangeOne"
                  @panelChange="panelChangeOne"
                  class="form-item-right"
                />
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>所属部门
              </div>
              <div class="pl16">
                <a-input
                  class="input-style-2"
                  type="text"
                  placeholder="请输入所属部门"
                  :maxLength="100"
                  v-model="info.belongDepartment"
                  :disabled="!isRevise || isScore"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>建设日期
              </div>
              <div class="pl16">
                <a-date-picker
                  placeholder="请选择建设日期"
                  v-model="info.foundTime"
                  :disabled="!isRevise || isScore"
                  :format="'YYYY-MM-DD'"
                  :locale="locale"
                  class="form-item-right"
                />
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>品牌层级
              </div>
              <div class="pl16">
                <a-radio-group
                  v-model="info.brandClassify"
                  :disabled="!isRevise || isScore"
                  @change="handleChangebrandClassify"
                >
                  <a-radio value="0"> 校园文化品牌 </a-radio>
                  <a-radio value="1"> 专业文化品牌 </a-radio>
                </a-radio-group>
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>品牌文化
              </div>
              <div class="pl16">
                <!-- 添加key属性用于强制重新渲染 -->
                <el-cascader
                  ref="cascaderRef"
                  :key="cascaderKey"
                  :disabled="!isRevise || isScore"
                  :options="kcList"
                  :props="cascaderProps"
                  placeholder="请选择品牌文化"
                  @change="onChange"
                  v-model="info.brandLabels"
                  style="width: 100%"
                  filterable
                  @keydown.native="handleEnterKey"
                ></el-cascader>

                <!-- <a-cascader
              :disabled="!isRevise || isScore"
              :options="kcList"
              placeholder="请选择品牌文化"
              @change="onChange"
              :show-search="{ filter }"
              :fieldNames="fieldNames"
              v-model="info.brandLabels"
              style="width: 100%"
              @search="handleSearch"
              @keydown.enter.native="handleEnterKey"
            /> -->
                <!--brandLabels-->
                <!--<a-select
            mode="tags"
            style="width:100%;"
            v-model="info.course"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
            placeholder="请选择课程"
           >
            <a-select-option v-for="item in kcList" :value="item.name">
               {{item.name}}
           </a-select-option>
          </a-select>-->
              </div>
            </div>
          </div>
          <div class="mt30" v-if="isShowZy">
            <div class="form-item" style="width: 100%">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span> 所属专业
              </div>
              <div
                class="pl16"
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <a-select
                  style="width: 32%"
                  show-search
                  v-model="info.basicMajorCategory"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  :disabled="isEdit || isScore"
                  @change="handleChange"
                >
                  <a-select-option value="">请选择专业大类</a-select-option>
                  <a-select-option
                    v-for="item in zydlList"
                    :value="item.id"
                    :key="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <a-select
                  style="width: 32%"
                  show-search
                  v-model="info.basicMajorSubclass"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  :disabled="isEdit || isScore"
                  @change="handleChange1"
                >
                  <a-select-option value="">请选择专业子类</a-select-option>
                  <a-select-option
                    v-for="item in zyzlList"
                    :value="item.id"
                    :key="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <a-select
                  style="width: 32%"
                  show-search
                  v-model="info.basicMajor"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  :disabled="isEdit || isScore"
                >
                  <a-select-option value="">请选择专业</a-select-option>
                  <a-select-option
                    v-for="item in zyList"
                    :value="item.id"
                    :key="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item" style="width: 100%">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>品牌内涵
              </div>
              <div class="pl16">
                <!-- <a-input
              placeholder="关键字之间以空格隔开"
              v-model="info.keyword"
              :disabled="!isRevise"
              @input="keywordInput"
            >
            </a-input>
            <div class="keywordBox" v-if="tags.length">
              <a-tag
                :closable="!isRevise"
                @close="handleClose(index)"
                :disabled="!isRevise"
                :key="index"
                v-for="(tag, index) in tags"
                >{{ tag }}</a-tag
              >
            </div> -->
                <a-select
                  mode="tags"
                  v-model="info.keyword"
                  placeholder="请选择品牌内涵"
                  @change="handleChangeKeyword"
                  style="width: 100%"
                  class="keywordSelect"
                  :disabled="!isRevise || isScore"
                >
                  <a-select-option
                    v-for="tag in ppnhList"
                    :key="tag.value"
                    :value="tag.value"
                  >
                    {{ tag.title }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <!--<div class="mt30">
        <div>
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 联系电话
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              :maxLength="11"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入联系电话"
              v-model="info.phone"
              :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
            />
          </div>
        </div>
      </div>-->
          <!-- <div class="text1">申报书模板下载</div>
        <div class="flex align-items-center">
          <img class="img-box-4" src="../../assets/images/img39.png" alt="" />
          <div class="text2" style="color: #2155B5; cursor: pointer">
            <a
              href="/思政教育工作室项目申报书.docx"
              download="思政微课项目申报书.docx"
              style="color: #2155B5"
            >
              思政教育工作室申报书.docx</a
            >
            <span class="text2">(32.2KB)</span>
          </div>
        </div>
      </div> -->
          <div class="mt30">
            <div class="form-item-upload" style="width: 100%">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>
                申报书上传
              </div>
              <div class="pl16">
                <a-upload
                  :file-list="fileList"
                  :disabled="!isRevise || isScore"
                  :remove="(file, fileList) => handleRemove(file, fileList)"
                  :before-upload="
                    (file, fileList) => beforeUpload(file, fileList)
                  "
                  accept=".pdf"
                  @preview="handlePreview"
                >
                  <a-button
                    :disabled="!isRevise || loading || isScore"
                    :loading="loading"
                  >
                    <a-icon type="upload" /> 上传附件
                  </a-button>
                  <span class="text2"> 注：请上传pdf格式的文件</span>
                </a-upload>
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f; opacity: 0">*</span>品牌熟知率
              </div>
              <div class="pl16 flex align-items-center">
                <a-input-number
                  v-model="info.brandExposureRate"
                  precision="0"
                  :disabled="!isRevise || isScore"
                  class="percentage-text"
                />
                <span class="percentage-sign">%</span>
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f; opacity: 0">*</span>好评率
              </div>
              <div class="pl16 flex align-items-center">
                <a-input-number
                  :disabled="!isRevise || isScore"
                  v-model="info.goodRate"
                  precision="0"
                  class="percentage-text"
                />
                <span class="percentage-sign">%</span>
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f; opacity: 0">*</span>教师参与率
              </div>
              <div class="pl16 flex align-items-center">
                <a-input-number
                  :disabled="!isRevise || isScore"
                  v-model="info.teacherParticipationRate"
                  precision="0"
                  class="percentage-text"
                />
                <span class="percentage-sign">%</span>
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f; opacity: 0">*</span>学生参与率
              </div>
              <div class="pl16 flex align-items-center">
                <a-input-number
                  :disabled="!isRevise || isScore"
                  v-model="info.studentParticipationRate"
                  min="0"
                  precision="0"
                  class="percentage-text"
                />
                <span class="percentage-sign">%</span>
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f; opacity: 0">*</span>品牌公众号
              </div>
              <div class="pl16">
                <a-input
                  class="input-style-2"
                  type="text"
                  placeholder="请输入品牌公众号"
                  :maxLength="100"
                  v-model="info.weChatPublicAccount"
                  :disabled="!isRevise || isScore"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f; opacity: 0">*</span>宣传地址
              </div>
              <div class="pl16">
                <a-input
                  class="input-style-2"
                  type="text"
                  placeholder="请输入宣传地址"
                  :maxLength="100"
                  v-model="info.promotionAddress"
                  :disabled="!isRevise || isScore"
                />
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item-upload" style="width: 100%">
              <div class="main-text-style">
                <span style="color: #f6350f; opacity: 0">*</span>
                活动方案
              </div>
              <div class="pl16">
                <a-upload
                  :file-list="activityfileList"
                  :disabled="!isRevise || isScore"
                  :remove="
                    (file, fileList) => handleRemoveActivity(file, fileList)
                  "
                  :before-upload="
                    (file, fileList) => beforeUploadActivity(file, fileList)
                  "
                  accept=".pdf"
                  @preview="handleActivePreview"
                >
                  <a-button
                    :disabled="!isRevise || activityLoading || isScore"
                    :loading="activityLoading"
                  >
                    <a-icon type="upload" /> 上传方案
                  </a-button>
                  <span class="text2"> 注：请上传pdf格式的文件</span>
                </a-upload>
              </div>
            </div>
          </div>
          <!-- <template v-if="isRevise">
            <div class="submit-btn-box">
              <div class="btn-group">
                <a-button type="primary" class="btn-action" @click="goStep"
                  >保存</a-button
                >
               
              </div>
            </div>
          </template> -->
        </div>
        <div class="preview-pop-box" v-if="showiframe">
          <div class="preview-boxs" style="height: 90%">
            <newpreview
              :previewUrl="previewUrl"
              @closePreview="showiframe = false"
              :dialogTitle="dialogTitle"
            ></newpreview>
          </div>
        </div>
        <a-modal
          title="重新审核"
          width="50%"
          :visible="isCheck"
          :maskClosable="false"
          :keyboard="false"
          @cancel="handleCancelCheck"
          @ok="handleCheck"
          ok-text="确认"
          cancel-text="取消"
          :destroyOnClose="true"
        >
          <p>检测到您修改了基本信息，将进行重新提交审核</p>
        </a-modal>
      </div>
    </a-modal>
  </div>
</template>
  <script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { baseURL } from "@/utils/request.js";
import { postAction, getAction } from "@/api";
import evidencelist from "@/components/common/evidencelist";
import newpreview from "@/components/common/newpreviews";
export default {
  name: "",
  components: {
    evidencelist,
    newpreview,
  },
  data() {
    return {
      visible: false,
      isEdit: false,
      isRevise: true,
      cascaderProps: {
        multiple: true,
        label: "name",
        value: "id",
        children: "children",
      },
      // 用于强制重新渲染级联选择器
      cascaderKey: Date.now(),
      cascaderRef: null, // 添加ref引用
      isCheck: false,
      checkState: false,
      submitParams: null,
      dialogTitle: "",
      info: {
        id: "",
        applyType: "2",
        name: "",
        applyYear: "",
        belongDepartment: "",
        foundTime: "",
        brandClassify: "0",
        brandLabels: [],
        weChatPublicAccount: "",
        promotionAddress: "",
        brandExposureRate: "",
        goodRate: "",
        teacherParticipationRate: "",
        studentParticipationRate: "",
        declarationName: "",
        declarationPath: "",
        // 活动方案
        activityPlanName: "",
        activityPlanPath: "",
        keyword: "",
        brandConnotation: "",
        // 专业
        basicMajorCategory: "",
        basicMajorSubclass: "",
        basicMajor: "",
      },
      zh_CN,
      locale,
      yearShowOne: false,
      path: baseURL,
      fileList: [],
      activityfileList: [],
      loading: false,
      tags: [],
      inputVisible: false,
      kcList: [],
      fieldNames: { label: "name", value: "id", children: "children" },
      zydlList: [],
      zyzlList: [],
      zyList: [],
      // 是否显示专业
      isShowZy: false,
      // 品牌内涵
      ppnhList: [],
      searchText: "",
      searchTimeout: null,
      activityLoading: false,
      isScore: false,
      showiframe: false,
      previewUrl: "",
      taskId: null,
      detailId: null,
    };
  },
  methods: {
    init(type, data, taskId, detailId) {
      this.zydl();
      this.getkclist();
      this.getPpnhlist();
      this.visible = true;
      this.taskId = taskId;
      this.detailId = detailId;
      if (data != null) {
        this.info = data;
        // 改进brandLabels处理
        if (data.brandLabels) {
          // 统一转换为数组
          try {
            const labelsArray = Array.isArray(data.brandLabels)
              ? data.brandLabels
              : JSON.parse(data.brandLabels || "[]");

            console.log("🚀 ~ handler ~ labelsArray:", labelsArray);
            this.info.brandLabels = labelsArray;

            // 确保动态选项存在
            this.$nextTick(() => {
              this.processDynamicOptions();
            });
          } catch (e) {
            console.error("解析brandLabels失败:", e);
            this.info.brandLabels = [];
          }
        } else {
          this.info.brandLabels = [];
        }
        // 品牌内涵初始化（确保转为数组）
        if (data.brandConnotation) {
          this.info.keyword = Array.isArray(data.brandConnotation)
            ? data.brandConnotation
            : data.brandConnotation.split(",");
        } else {
          this.info.keyword = [];
        }
        if (
          data &&
          data.declarationName != "" &&
          data.declarationName != null &&
          data.declarationPath != "" &&
          data.declarationPath != null
        ) {
          this.fileList = [];
          let fileItem = {};
          fileItem.path = data.declarationPath;
          fileItem.name = data.declarationName;
          fileItem.uid = 1;
          this.fileList.push(fileItem);
        }
        // 活动方案 activityPlanName activityPlanPath
        if (
          data &&
          data.activityPlanName != "" &&
          data.activityPlanName != null &&
          data.activityPlanPath != "" &&
          data.activityPlanPath != null
        ) {
          this.activityfileList = [];
          let fileItem = {};
          fileItem.path = data.activityPlanPath;
          fileItem.name = data.activityPlanName;
          fileItem.uid = 1;
          this.activityfileList.push(fileItem);
        }
        if (
          data.brandConnotation != "" &&
          data.brandConnotation.indexOf(",") == "-1"
        ) {
          this.tags = [];
          this.tags.push(data.brandConnotation);
        } else {
          if (data && data.brandConnotation != "") {
            this.tags = data.brandConnotation.split(",");
          }
        }
        // 专业文化品牌 显示专业
        if (data && data.brandClassify == "1") {
          this.isShowZy = true;
        }
        if (
          data.basicMajorCategory != "null" &&
          data.basicMajorCategory != ""
        ) {
          this.zyzl(data.basicMajorCategory);
        }
        if (
          data.basicMajorSubclass != "null" &&
          data.basicMajorSubclass != ""
        ) {
          this.zylist(data?.basicMajorSubclass);
        }
        // 转换数字字段
        const numberFields = [
          "brandExposureRate",
          "goodRate",
          "teacherParticipationRate",
          "studentParticipationRate",
        ];
        numberFields.forEach((field) => {
          if (data[field] !== undefined && data[field] !== null) {
            this.info[field] = Number(data[field]) || 0;
          }
        });

        this.info.basicMajorSubclass = data.basicMajorSubclass;
        this.info.basicMajor = data.basicMajor;
      }
      console.log("🚀 ~ init ~ this.info:", this.info);
    },
    handleClose(tag) {
      console.log("this.isEdit   handleClose", this.isEdit);
      if (!this.isEdit) {
        this.tags.splice(tag, 1);
        this.info.keyword = this.tags.join(" ");
      }
    },

    // 处理回车键
    handleEnterKey(e) {
      if (e.target.tagName === "INPUT" && e.key === "Enter") {
        e.preventDefault();
        const searchValue = e.target.value.trim();
        if (searchValue) {
          this.addDynamicOption(searchValue);
          // 清空搜索框
          setTimeout(() => {
            e.target.value = "";
          }, 0);
        }
      }
    },

    // 修改动态添加选项的方法
    async addDynamicOption(searchValue) {
      if (!searchValue) return;

      // 检查是否已存在相同选项
      const exists = this.kcList.some(
        (option) =>
          option.id === searchValue ||
          (option.name &&
            option.name.toLowerCase() === searchValue.toLowerCase())
      );

      if (!exists) {
        const newOption = {
          id: searchValue,
          name: searchValue,
          parentId: "0",
          children: [
            {
              id: `son-${searchValue}`,
              parentId: "searchValue",
              sort: 2,
              name: searchValue,
            },
          ],
          sort: 0,
        };

        // 使用Vue.set确保响应式更新
        this.kcList = [newOption, ...this.kcList];

        // 确保brandLabels是数组
        if (!Array.isArray(this.info.brandLabels)) {
          try {
            this.info.brandLabels = JSON.parse(this.info.brandLabels || "[]");
          } catch (e) {
            console.error("解析brandLabels失败:", e);
            this.info.brandLabels = [];
          }
        }

        // 检查是否已经包含这个值
        const valueAlreadyExists = this.info.brandLabels.some(
          (item) =>
            Array.isArray(item) && item.length > 0 && item[0] === searchValue
        );

        if (!valueAlreadyExists) {
          // 添加新选项到选中值
          const newValue = [searchValue, `son-${searchValue}`];

          this.info.brandLabels = [...this.info.brandLabels, newValue];

          // 强制级联选择器重新渲染
          this.forceCascaderRerender();

          // 等待DOM更新后手动触发change事件
          await this.$nextTick();
          this.onChange(this.info.brandLabels);
        }

        this.$message.success(`已添加选项: ${searchValue}`);
      } else {
        this.$message.warning("该选项已存在");
      }
    },

    // 修改处理动态选项的方法
    processDynamicOptions() {
      if (!this.info.brandLabels || !Array.isArray(this.info.brandLabels)) {
        return;
      }

      const dynamicOptions = [];
      const existingOptions = new Set();

      // 收集所有现有的选项ID和name
      this.collectOptionIdsAndNames(this.kcList, existingOptions);

      this.info.brandLabels.forEach((labelArray, index) => {
        if (Array.isArray(labelArray) && labelArray.length > 0) {
          const topLevelLabel = labelArray[0];

          // 检查是否为字符串（动态添加的选项）
          if (
            typeof topLevelLabel === "string" &&
            topLevelLabel &&
            !existingOptions.has(topLevelLabel)
          ) {
            if (!dynamicOptions.some((opt) => opt.id === topLevelLabel)) {
              dynamicOptions.push({
                id: topLevelLabel,
                name: topLevelLabel,
                parentId: "0",
                children: [
                  {
                    id: `son-${topLevelLabel}`,
                    parentId: "topLevelLabel",
                    sort: 2,
                    name: topLevelLabel,
                  },
                ],
                sort: 0,
              });
            }
          }
        }
      });

      if (dynamicOptions.length > 0) {
        // 使用Vue.set确保响应式更新
        this.kcList = [...dynamicOptions, ...this.kcList];
        console.log("🚀 ~ processDynamicOptions ~ this.kcList:", this.kcList);

        // 强制重新渲染
        this.$nextTick(() => {
          this.forceCascaderRerender();
        });
      }
    },

    // 修改收集选项ID和name的方法
    collectOptionIdsAndNames(options, existingSet) {
      options.forEach((option) => {
        if (option.id) {
          existingSet.add(option.id);
        }
        if (option.name) {
          existingSet.add(option.name);
        }
        if (option.children && option.children.length > 0) {
          this.collectOptionIdsAndNames(option.children, existingSet);
        }
      });
    },
    onChange(value) {
      console.log("🚀 ~ onChange ~ value:", value);
      this.info.brandLabels = value;

      // 确保视图更新
      this.$forceUpdate();
    },
    // 获取品牌文化列表
    getkclist() {
      getAction("/lxbase/lxBrandLabel/treeList", {}).then((res) => {
        if (res.code === 200) {
          let data = res.result || [];
          this.kcList = data;

          // 确保brandLabels是数组
          if (this.info.brandLabels && !Array.isArray(this.info.brandLabels)) {
            try {
              this.info.brandLabels = JSON.parse(this.info.brandLabels || "[]");
            } catch (e) {
              console.error("解析brandLabels失败:", e);
              this.info.brandLabels = [];
            }
          }

          // 处理动态添加的选项回显
          this.processDynamicOptions();

          // 强制重新渲染
          this.forceCascaderRerender();
        }
      });
    },
    // 强制级联选择器重新渲染
    forceCascaderRerender() {
      this.cascaderKey = Date.now();
    },
    // 获取品牌内涵
    getPpnhlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=brand_connotation").then(
        (res) => {
          if (res.code == 200) {
            this.ppnhList = res.result;
          }
        }
      );
    },
    // 品牌内涵改变
    handleChangeKeyword(newTags) {
      // 合并新标签到选项列表
      const newItems = newTags
        .filter((tag) => !this.ppnhList.some((opt) => opt.value === tag))
        .map((tag) => ({ title: tag, value: tag }));

      this.ppnhList = [...this.ppnhList, ...newItems];
      this.info.keyword = newTags;
    },
    // 获取专业大类
    zydl() {
      getAction("/infrastructure/basicMajorCategory/allList", {}).then(
        (res) => {
          console.log(res);
          if (res.code === 200) {
            let data = res.result;
            if (data) {
              this.zydlList = data;
            }
          }
        }
      );
    },
    handleChange(value) {
      this.zyzl(value);
      this.info.basicMajorSubclass = "";
      this.info.basicMajor = "";
      this.zyList = [];
    },
    handleChange1(value) {
      this.zylist(value);
      this.info.basicMajor = "";
    },
    zyzl(id) {
      getAction("/infrastructure/basicMajorSubclass/queryByCategoryId", {
        gategoryId: id,
      }).then((res) => {
        //			console.log(res);
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyzlList = data;
          }
        }
      });
    },
    zylist(id) {
      getAction("/infrastructure/basicMajor/queryBySubclassId", {
        subclassId: id,
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyList = data;
          }
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangebrandClassify(e) {
      const value = e.target.value;
      if (value == 0) {
        this.isShowZy = false;
        return;
      }
      if (value == 1) {
        this.isShowZy = true;
        //this.zydl();
      }
    },
    // getkclist() {
    //   getAction("/lxbase/lxBrandLabel/treeList", {}).then((res) => {
    //     if (res.code === 200) {
    //       let data = res.result;
    //       if (data) {
    //         this.kcList = data;
    //         // 检查是否有动态添加的选项需要回显
    //         this.info.brandLabels.forEach((label) => {
    //           if (!this.kcList.some((item) => item.id === label)) {
    //             this.kcList.unshift({
    //               id: label,
    //               name: label,
    //               isDynamic: true,
    //               children: [],
    //             });
    //           }
    //         });
    //       }
    //     }
    //   });
    // },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      if (inputValue.length > 30) {
        return false;
      }
      let tags = this.tags;
      //    if (tags.length >= 5) {
      //      this.$message.warn('团队成员不能超过个4成员！');
      //      return false;
      //    }
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: "",
      });
    },
    handleClose(tag) {
      console.log("this.isEdit   handleClose", this.isEdit);
      if (!this.isEdit) {
        this.tags.splice(tag, 1);
        this.info.keyword = this.tags.join(" ");
      }
    },
    keywordInput() {
      this.tags = this.info.keyword.split(" ").filter((item) => item != "");
      if (this.info.keyword == "") {
        this.tags = [];
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (this.fileList.length >= 1) {
        this.$message.error("申报书只能上传一个文件,请移除后再上传");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    handlePreview(file) {
      if (
        this.$store.state.role === "score-role" ||
        this.$store.state.role === "education-role"
      ) {
        this.showiframe = true;
        this.previewUrl = this.oldInfos.declarationPath;
        this.dialogTitle = "申报书预览";
      }
    },
    // 上传活动方案
    handleRemoveActivity() {
      this.activityfileList = this.activityfileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.activityfileList.indexOf(file);
      const newFileList = this.activityfileList.slice();
      newFileList.splice(index, 1);
      this.activityfileList = newFileList;
    },
    beforeUploadActivity(file, fileList) {
      this.handleUploadActivity(file);
      return false;
    },
    handleUploadActivity(file) {
      if (this.activityfileList.length >= 1) {
        this.$message.error("活动方案只能上传一个文件,请移除后再上传");
        return;
      }
      this.activityLoading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.activityfileList.push(fileItem);
          this.activityLoading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    handleActivePreview(file) {
      if (
        this.$store.state.role === "score-role" ||
        this.$store.state.role === "education-role"
      ) {
        this.showiframe = true;
        this.previewUrl = this.oldInfos.activityPlanPath;
        this.dialogTitle = "活动方案";
      }
    },
    // 得到年份选择器的值
    panelChangeOne(value) {
      this.info.applyYear = value;
      this.yearShowOne = false;
    },
    goStep() {
      if (this.info && this.info.name === "") {
        if (this.info.name === "" || this.info.name == undefined) {
          this.$message.info("请填写品牌名称");
          return false;
        }
      }
      if (
        (this.info && this.info.applyYear === "") ||
        this.info.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      }
      if (this.info && this.info.belongDepartment === "") {
        if (
          this.info.belongDepartment === "" ||
          this.info.belongDepartment == undefined
        ) {
          this.$message.info("请填写所属部门");
          return false;
        }
      }
      if (this.info && this.info.foundTime === "") {
        if (this.info.foundTime === "" || this.info.foundTime == undefined) {
          this.$message.info("请选择建设日期");
          return false;
        }
      }
      if (this.info && this.info.brandClassify === "") {
        if (
          this.info.brandClassify === "" ||
          this.info.brandClassify == undefined
        ) {
          this.$message.info("请选择品牌层级");
          return false;
        }
      }
      if (!this.info.brandLabels) {
        this.$message.info("请选择品牌文化");
        return false;
      }
      if (
        this.info &&
        this.info.brandLabels &&
        this.info.brandLabels.length == "0"
      ) {
        if (
          this.info.brandLabels.length == "0" ||
          this.info.brandLabels == undefined
        ) {
          this.$message.info("请选择品牌文化");
          return false;
        }
      }
      // if (this.info && this.info.weChatPublicAccount === "") {
      //   if (
      //     this.info.weChatPublicAccount === "" ||
      //     this.info.weChatPublicAccount == undefined
      //   ) {
      //     this.$message.info("请填写品牌公众号");
      //     return false;
      //   }
      // }
      // if (this.info && this.info.promotionAddress === "") {
      //   if (
      //     this.info.promotionAddress === "" ||
      //     this.info.promotionAddress == undefined
      //   ) {
      //     this.$message.info("请填写宣传地址");
      //     return false;
      //   }
      // }
      if (this.info && this.info.brandExposureRate === "") {
        if (
          this.info.brandExposureRate === "" ||
          this.info.brandExposureRate == undefined
        ) {
          this.$message.info("请输入品牌熟知率");
          return false;
        }
      }
      if (this.info && this.info.goodRate === "") {
        if (this.info.goodRate === "" || this.info.goodRate == undefined) {
          this.$message.info("请输入好评率");
          return false;
        }
      }
      if (this.info && this.info.teacherParticipationRate === "") {
        if (
          this.info.teacherParticipationRate === "" ||
          this.info.teacherParticipationRate == undefined
        ) {
          this.$message.info("请输入教师参与率");
          return false;
        }
      }
      if (this.info && this.info.studentParticipationRate === "") {
        if (
          this.info.studentParticipationRate === "" ||
          this.info.studentParticipationRate == undefined
        ) {
          this.$message.info("请输入学生参与率");
          return false;
        }
      }
      if (this.fileList.length == 0) {
        this.$message.info("请上传申报书");
        return false;
      }
      // if (this.activityfileList.length == 0) {
      //   this.$message.info("请上传活动方案");
      //   return false;
      // }
      if (this.tags.length == "0") {
        this.$message.info("请输入品牌内涵关键词");
        return false;
      }
      //     if (
      //      (this.info && this.info.brandMode === "") ||
      //      this.info.brandMode == undefined
      //    ) {
      //      this.$message.info("请填写品牌模式");
      //      return false;
      //    }

      // if (
      //   (this.info && this.info.izCheritage === "") ||
      //   this.info.izCheritage == undefined
      // ) {
      //   this.$message.info("请选择是否非遗");
      //   return false;
      // }

      const isPreview = this.$parent.editInfo?.type == "preview";
      // 控制名称、年份的编辑 ,包括编辑按钮的显隠
      //this.isEdit = isPreview;
      // 控制其余项的编辑
      //this.isRevise = isPreview;
      // 控制下面表格的操作按钮是否可用
      //this.$emit("onRevise", !isPreview);
      const dateObj = new Date(this.info.foundTime);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
      const date = dateObj.getDate();
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;
      let brandLabels = this.info.brandLabels || [];
      this.info.brandConnotation = this.info.keyword.join(",");
      let params = {
        ...this.info,
        foundTime: formattedDate,
        brandLabels: JSON.stringify(brandLabels),

        applyYear: new Date(this.info.applyYear).getFullYear() + "",
        declarationName: this.fileList[0].name,
        declarationPath: this.fileList[0].path,
        brandConnotation: this.info.brandConnotation,
      };
      if (this.activityfileList && this.activityfileList.length != 0) {
        this.info.activityPlanName = this.activityfileList[0].name;
        this.info.activityPlanPath = this.activityfileList[0].path;
        params.activityPlanName = this.activityfileList[0].name;
        params.activityPlanPath = this.activityfileList[0].path;
      }
      this.info.declarationName = this.fileList[0].name;
      this.info.declarationPath = this.fileList[0].path;
      this.submitParams = { ...params };
      const auditParams = {
        taskId: this.taskId,
        afterJson: JSON.stringify({ ...params }),
        detailId: this.detailId,
      };
      this.save(auditParams);
    },
    handleCheck() {
      const checkParams = { ...this.submitParams, checkState: this.checkState };
      this.save(checkParams);
    },
    handleCancelCheck() {
      this.isCheck = false;
    },
    save(params) {
      postAction("/audit/lxAuditTask/reSubmitTask", params).then((res) => {
        if (res.code == 200) {
          // if (this.isAdd) {
          //   this.$message.success("添加成功");
          // } else {
          //   this.$message.success("编辑成功");
          // }
          this.$message.success(res.message || "保存成功");
          this.info.id = res.result.id;
          this.visible = false;
          this.$emit("init", this.info);
          this.handleCancelCheck();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onClean() {
      this.isEdit = false;
    },
    handleCancel() {
      this.visible = false;
    },
  },
  mounted() {},
};
</script>
  <style scoped lang="scss">
.card-item {
  //   background: #ffffff;
  //   box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
  //   padding: 37px 20px;
  //   box-sizing: border-box;
  //   margin-bottom: 24px;
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    border-bottom: 1px solid #d9d9d9;
    .title-text {
      color: #2155b5;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      border-bottom: 3px solid #2155b5;
      padding: 0px 4px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.mt30 {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-item {
    display: flex;
    align-items: center;
    width: 50%;
    margin-bottom: 10px;
    .main-text-style {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #121212;
      margin-bottom: 15px;
      width: 165px;
    }
    .pl16 {
      width: calc(100%- 235px);
    }
    .form-item-right {
      width: 100%;
    }
    // .form-item-right {
    //   width: 240px;
    // }
  }
  .form-item-upload {
    display: flex;
    align-items: center;
    .main-text-style {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 15px;
      width: 165px;
    }
    .form-item-right {
      width: 240px;
    }
  }
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
    margin-top: 50px;
    .btn-action {
      width: 116px;
      height: 40px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      line-height: 38px;
      text-align: center;
    }
  }
}

.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
// /deep/ .ant-calendar-picker {
//   width: 50%;
// }
/deep/ .ant-input {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.plflex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin: 20px;
  width: 165px;
}
.mb15-item {
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.file-input-box {
  color: #2155b5;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155b5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
.percentage-text {
  width: 86%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.percentage-sign {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  // color: #999;
  margin: 14px 0 15px 10px;
  color: #e5914b;
  cursor: pointer;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>